

import React, { useEffect, useMemo, useRef, useState } from 'react';
//  CODE FOR ONE PAGE
import LayerPanelPage from "./LayerPanelPage";
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import "@arcgis/core/assets/esri/themes/light/main.css";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Query from "@arcgis/core/rest/support/Query";
//Graphic show on map
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Graphic from "@arcgis/core/Graphic";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import Home from "@arcgis/core/widgets/Home";
import ScaleBar from "@arcgis/core/widgets/ScaleBar.js";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery.js";
import Locate from "@arcgis/core/widgets/Locate.js";
import Expand from "@arcgis/core/widgets/Expand";
import Legend from "@arcgis/core/widgets/Legend";
import Search from "@arcgis/core/widgets/Search";
import Print from "@arcgis/core/widgets/Print";
import LayerList from "@arcgis/core/widgets/LayerList.js";
import Zoom from "@arcgis/core/widgets/Zoom";
import Measurement from "@arcgis/core/widgets/Measurement";

import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { setIsDist, setIsUlb, setIsWard } from "../../store/slice/currentStageSlice";


// OTHERS Control
import MapPropetyInfo from '../../componets/MapPropetyInfo';
import LayerControlPanel from '../../componets/LayerControlPanel';

import html2canvas from 'html2canvas';
import PropertyMISInfo from '../../componets/PropertyMISInfo';
// === Service URLs ===
// Others Control


const baseURL = "https://urbangis.mp.gov.in/server";
// Layer definitions
const mainLayerUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";



function MapPointDist({ isWidth, isScreenSize, isByDefaultActive }) {


    const [active, setActive] = useState("total");
    const [activeSelect, setActiveSelect] = useState("area");


    const [tabLocation, setTabLocation] = useState(false);
    const { isTheme, isBufferWidth, isToolHeight, currentStageValue, isSideBar } = useSelector((state) => state.currentStage);
    const { bufferData, selectedBuffer, setFeatureTable } = useSelector((state) => state.buffer);

    const [isScreenSize1, setIsScreenSize1] = useState(window.innerWidth <= 991);
    const dispatch = useDispatch()
    const [districts, setDistricts] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [districtCode, setDistrictCode] = useState("");
    const authData = useSelector(state => state.authToken.authData);

    const [ulbs, setUlbs] = useState([]);
    const [selectedUlb, setSelectedUlb] = useState("");
    const [ulbCode, setUlbCode] = useState("");

    const [wards, setWards] = useState([]);
    const [selectedWard, setSelectedWard] = useState("");
    const [wardCode, setWardCode] = useState("");


    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);

    const [filteredPropertyData, setFilteredPropertyData] = useState([]);


    const [search, setSearch] = useState("");
    const [expanded, setExpanded] = useState({});
    const [checked, setChecked] = useState({});

    const [isLoading, setIsLoading] = useState(false);
    const [isTableLoading, setIsTableLoading] = useState(false);

    // State for PrimeReact DataTable
    const [columns, setColumns] = useState([]);
    const [first, setFirst] = useState(0); // Index of the first record
    const [rows, setRows] = useState(500); // Rows per page

    const [searchField, setSearchField] = useState("ownername");
    const [searchResults, setSearchResults] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);

    const debounceRef = useRef(null);
    const abortRef = useRef(null);


    // State for PrimeReact DataTable

    //   NEW TOOLS 2025
    // 30 DEC 2025 
    const layerRef = useRef(null);
    const [map, setMap] = useState(null);
    const mapDiv = useRef(null);


    // TABLE DATA
   

    const [PROPERTY_Relation_Id, setPROPERTY_Relation_Id] = useState("0");
    //  DATA
    //  NEW STATE 
    //  BHUPEN LAYER CODE


    const buildFilter = (dist_cd, ulb_cd, wardno) => {
        const conditions = [];
        if (dist_cd) conditions.push(`dist_cd = '${dist_cd}'`);
        if (ulb_cd) conditions.push(`ulb_cd = '${ulb_cd}'`);
        if (wardno) conditions.push(`wardno = '${wardno}'`);
        return conditions.length > 0 ? conditions.join(" AND ") : "1=1";
    };



    const [view, setView] = useState(null);


    // SECTION - MAP
    const mapRef = useRef(null);     // DOM reference
    const viewRef = useRef(null);    // ArcGIS MapView reference

    useEffect(() => {
        // Create the base map and view only once
        if (!viewRef.current) {
            const map = new Map({
                basemap: "topo-vector",
            });

            const view = new MapView({
                container: mapRef.current,
                map: map,
                center: [78.6569, 23.2599], // Center on MP
                zoom: 6,
                ui: { components: ["attribution"] }
            });

            viewRef.current = view;
            const layer = new MapImageLayer({ url: mainLayerUrl, sublayers: [] });
            map.add(layer);
            layerRef.current = layer;
            setView(view);


            // POP DOC
            view.when(() => {
                view.popup.dockEnabled = true;
                view.popup.dockOptions = {
                    position: "bottom-left",
                    breakpoint: false
                };
            });

            // code for Legend
            view.ui.add(new Search({ view: view }), "top-left");
            view.ui.add(new Home({ view: view }), "top-left");
            view.ui.add(new Zoom({ view: view }), "top-left");
            view.ui.add(new Expand({ view: view, content: new BasemapGallery({ view: view }) }), "top-right");
            view.ui.add(new Locate({ view: view, graphic: new Graphic({ symbol: { type: "simple-marker" } }) }), "top-right");
            view.ui.add(new ScaleBar({ view: view }), "bottom-right");

            view.when(() => {
                const printWidget = new Print({
                    view: view,
                    printServiceUrl: "https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"
                });
                const expandPrint = new Expand({
                    view: view,
                    content: printWidget
                });

                view.ui.add(expandPrint, "top-right");

                // ✅ Add and attach legend
                const legendWidget = new Legend({
                    view: view,
                    style: "classic"
                });

                const legendExpand = new Expand({
                    view: view,
                    content: legendWidget,
                    expanded: false
                });

                view.ui.add(legendExpand, "top-right");

            });

            //  legend  layerList

            const layerList = new LayerList({
                view: view
            });

            const expand = new Expand({
                view: view,
                content: layerList,
                expanded: false
            });

            view.ui.add(expand, "top-right");

        }
    }, []);

    // SECTION - MAP



    useEffect(() => {
        const handleResize = () => {
            setIsScreenSize1(window.innerWidth <= 991)
        };
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])



    const handleRefresh = async () => {
        // Reset Map
        view.graphics.removeAll(); // Clear any highlights

        // Go to the initial extent or center
        view.goTo({
            center: [77.4126, 23.2599],
            zoom: 6,
            ui: { components: ["attribution"] }
        });




        // Reset all filter states
        setSelectedDistrict("");
        setDistrictCode("");
        setSelectedUlb("");
        setUlbCode("");
        setSelectedWard("");
        setWardCode("");


        // Reset dropdown options
        setUlbs([]);
        setWards([]);

        // Dispatch reset actions
        dispatch(setIsDist(""));
        dispatch(setIsUlb(""));
        dispatch(setIsWard(""));


        // Reset the map view to initial state

    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            boxShadow: state.isFocused && !state.hasValue ? "0 0 0 1px #ccc" : "none",
            borderColor: state.isFocused && !state.hasValue ? "#ccc" : "#ccc",
            "&:hover": {
                borderColor: "#ccc",
            },
            fontSize: "12px",
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? "#d1ede9"
                : state.isFocused
                    ? "#d1ede9"
                    : "#FFFFFF",
            color: "#000",
            fontSize: "12px",
            padding: "10px",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "#000",
            fontSize: "12px",
        }),
        placeholder: (base) => ({
            ...base,
            color: "#000",
            fontSize: "12px",
        }),
        input: (provided) => ({
            ...provided,
            color: "#000",
            fontSize: "12px",
        }),
    };



    // code for map 

    // BHUPEN CODE FOR MAP MAXIMIZE

    const [isMaximized, setIsMaximized] = useState(false);
    const toggleMaximize = () => {
        setIsMaximized(prev => !prev);
    };
    // BHUPEN CODE FOR MAP MAXIMIZE

    // Two Points  CODE FOR HIGHT

    const highlightLayerRef = useRef(null);
    useEffect(() => {
        if (!map || highlightLayerRef.current) return;

        const highlightLayer = new GraphicsLayer({
            title: "Highlight Layer"
        });

        map.add(highlightLayer); // Add once
        highlightLayerRef.current = highlightLayer;

    }, [map]);



    const blinkRef1 = useRef(null);

    if (blinkRef1.current) {
        clearInterval(blinkRef1.current);
        blinkRef1.current = null;
    }





    // CODE FOR DISTRICT ULB WARD
    // All dropdown loading functions (loadDistricts, loadUlbs, loadWards) remain unchanged.


    // Load Intial code for Second Layers
    useEffect(() => {

        const loadDistricts = async () => {

            const url = `${baseURL}/rest/services/temp_n/urbangis_temp/MapServer/3/query?where=1=1&outFields=districtname,dist_cd&returnGeometry=false&returnDistinctValues=true&f=geojson`;

            //alert(url);
            try {
                const response = await fetch(url);
                const data = await response.json();

                if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
                    const userDistrict = [{
                        districtName: authData.DistrictName,
                        districtCode: authData.DistrictCode,
                    }];
                    setDistricts(userDistrict);
                    setDistrictCode(authData.DistrictCode);
                    setSelectedDistrict(authData.DistrictName);
                    await loadUlbs(authData.DistrictCode);
                } else {
                    const formatted = data.features.map(f => ({
                        districtName: f.properties.districtname,
                        districtCode: f.properties.dist_cd,
                    }));
                    setDistricts(formatted);
                }
            } catch (err) {
                console.error("Error loading districts:", err);
            }
        };


        if (!view) return;

        handleTabClick(districtCode, ulbCode, wardCode);
        if (selectedWard && wardCode && ulbCode) {
            zoomToWard(wardCode, ulbCode);
        } else if (selectedUlb && ulbCode) {
            zoomToUlb(selectedUlb);
        } else if (selectedDistrict && districtCode) {
            zoomToDistrict(selectedDistrict);
        }
        loadDistricts();
    }, [selectedDistrict, selectedUlb, selectedWard, districtCode, ulbCode, wardCode, authData, view]);

    const zoomToDistrict = async (districtName) => {
        const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/3')}` });
        const query = new Query({ where: `districtname = '${districtName}'`, returnGeometry: true });
        try {
            const { features } = await layer.queryFeatures(query);
            if (features.length) {
                const graphic = new Graphic({
                    geometry: features[0].geometry,
                    symbol: {
                        type: "simple-fill",
                        color: [0, 0, 255, 0.0],
                        outline: { color: [0, 0, 255], width: 2 }
                    }
                });
                view.graphics.add(graphic);
                view.goTo(features[0].geometry.extent.expand(1.0));
            }
        } catch (error) {
            console.error("Error zooming to district:", error);
        }
    };

    const zoomToUlb = async (ulbName) => {
        const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/94')}` });
        const query = new Query({ where: `ulbname = '${ulbName}'`, returnGeometry: true });

        try {
            const { features } = await layer.queryFeatures(query);
            if (features.length) {
                const graphic = new Graphic({
                    geometry: features[0].geometry,
                    symbol: {
                        type: "simple-fill",
                        color: [0, 0, 255, 0.0],
                        outline: { color: [0, 0, 255], width: 2 }
                    }
                });
                view.graphics.add(graphic);
                view.goTo(features[0].geometry.extent.expand(1.0));
            }
        } catch (error) {
            console.error("Error zooming to ULB:", error);
        }
    };

    const zoomToWard = async (wardCode, ulbCode) => {
        const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/95')}` });
        const query = new Query({ where: `wardno = '${wardCode}' AND ulb_cd = '${ulbCode}'`, returnGeometry: true });

        try {
            const { features } = await layer.queryFeatures(query);
            if (features.length) {
                const graphic = new Graphic({
                    geometry: features[0].geometry,
                    symbol: {
                        type: "simple-fill",
                        color: [0, 0, 255, 0.0],
                        outline: { color: [0, 0, 255], width: 2 }
                    }
                });
                view.graphics.add(graphic);
                view.goTo(features[0].geometry.extent.expand(1.5));
            }
        } catch (error) {
            console.error("Error zooming to ward:", error);
        }
    };



    const loadUlbs = async (dist_cd) => {

        const url = `${baseURL}/rest/services/temp_n/urbangis_temp/MapServer/5/query?where=dist_cd='${dist_cd}'&returnGeometry=false&outFields=name,ulb_cd&returnDistinctValues=true&f=geojson`;


        try {
            const response = await fetch(url);
            const data = await response.json();
            if (authData?.UserType === "User") {
                const formattedUlbs = [{
                    ulbName: authData?.UlbName,
                    ulbCode: authData?.Ulb_Code,
                }];
                setUlbs(formattedUlbs);
                setUlbCode(authData?.Ulb_Code);
                setSelectedUlb(authData?.UlbName);
                await loadWards(authData?.Ulb_Code);
            } else if (data.features) {
                const formattedUlbs = data.features.map(f => ({
                    ulbName: f.properties.name,
                    ulbCode: f.properties.ulb_cd,
                }));
                setUlbs(formattedUlbs);
            }
        } catch (err) {
            console.error("Error loading ULBs:", err);
        }
    };

    const loadWards = async (ulb_cd) => {
        const url = `${baseURL}/rest/services/temp_n/urbangis_temp/MapServer/7/query?where=ulb_cd='${ulb_cd}'&returnGeometry=false&outFields=wardname,wardno&returnDistinctValues=true&f=geojson`;

        try {
            const response = await fetch(url);
            const data = await response.json();
            const formatted = data.features.map(f => ({
                wardName: f.properties.wardname,
                wardCode: f.properties.wardno,
                displayLabel: `${f.properties.wardno} - ${f.properties.wardname}`
            }));
            setWards(formatted);
        } catch (err) {
            console.error("Error loading wards:", err);
        }
    };

    const handleDistrictChange = async (selectedOption) => {
        if (!selectedOption) {
            handleRefresh();
            return;
        }
        const district = districts.find(d => d.districtCode === selectedOption.value);
        if (district) {
            setDistrictCode(district.districtCode);
            setSelectedDistrict(district.districtName);
            setUlbCode(""); setSelectedUlb(""); setWardCode(""); setSelectedWard("");
            await loadUlbs(district.districtCode);
            // fetchAndZoomPropertyChanges({ dist_cd: district.districtCode });
        }
    };

    const handleUlbChange = async (selectedOption) => {
        if (!selectedOption) {
            setUlbCode(""); setSelectedUlb(""); setWardCode(""); setSelectedWard("");
            // fetchAndZoomPropertyChanges({ dist_cd: districtCode }); // Refetch for the district
            return;
        }
        const ulb = ulbs.find(u => u.ulbCode === selectedOption.value);
        if (ulb) {
            setUlbCode(ulb.ulbCode); setSelectedUlb(ulb.ulbName); setWardCode(""); setSelectedWard("");
            await loadWards(ulb.ulbCode);
            // fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulb.ulbCode });
        }
    };

    const handleWardChange = async (selectedOption) => {
        if (!selectedOption) {
            setWardCode(""); setSelectedWard("");
            //  fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulbCode }); // Refetch for the ULB
            return;
        }
        const ward = wards.find(w => w.wardCode === selectedOption.value);
        if (ward) {
            setWardCode(ward.wardCode); setSelectedWard(ward.wardName);
            //  fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulbCode, wardno: ward.wardCode });
        }
    };

    // UPDATED data fetching function for PrimeReact

    const handleTabClick = (districtCode, ulbCode, wardCode) => {

        if (view && layerRef.current) {
            view.graphics.removeAll();
            // LoadZoom();
            view.map.removeAll();
            const filterExpr = buildFilter(districtCode, ulbCode, wardCode);
            const adminLayer = new MapImageLayer({
                url: mainLayerUrl,
                sublayers: [
                    { id: 1, title: "State", visible: true, definitionExpression: filterExpr },
                    { id: 3, title: "District", visible: true, definitionExpression: filterExpr },
                ]
            });

            view.map.add(adminLayer);
            layerRef.current = adminLayer;

            // code for image layer  GUNA
            const IMGLAyerGUNA = new MapImageLayer({
                url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/guna2017/MapServer",

                sublayers: [
                    { id: 0, title: "Guna-Satelite-2017", visible: false },

                ]
            });
            view.map.add(IMGLAyerGUNA);
            layerRef.current = IMGLAyerGUNA;
            // code for image layer GUNA

            if (view) {

                const filterExpr = buildFilter(districtCode, ulbCode, wardCode);
                const waterLayer = new MapImageLayer({
                    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/",
                    sublayers: [
                        {
                            id: 14, title: "Property", visible: true, definitionExpression: filterExpr,
                            popupEnabled: true,
                            popupTemplate: {
                                title: "🏠 Property Relation ID: {relation_id}",
                                content: async (feature) => {
                                    const attr = feature.graphic.attributes;
                                    const PROPERTY_Relation_Id = attr.relation_id;
                                    try {

                                        // ✅ FeatureLayer (Layer 97)
                                        const layer = new FeatureLayer({
                                            url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/MapServer/97"
                                        });

                                        const query = new Query({
                                            where: `relation_id='${PROPERTY_Relation_Id}'`,
                                            outFields: ["*"],
                                            returnGeometry: false
                                        });

                                        const result = await layer.queryFeatures(query);

                                        console.log("Layer 97 Result 👉", result);

                                        if (!result.features || result.features.length === 0) {
                                            return `
              <div style="color:red; padding:10px;">
                ❌ No data found for ID: ${PROPERTY_Relation_Id}
              </div>
            `;
                                        }

                                        const data = result.features[0].attributes;

                                        return `
    <div style="
      font-family:sans-serif;
      height:350px;
      display:flex;
      flex-direction:column;
    ">
    
      <!-- SCROLLABLE CONTENT -->
      <div style="
        overflow-y:auto;
        flex:1;
        padding:5px;
      ">
    
        <!-- HEADER -->
        <div style="
         background: rgba(12, 66, 80, 0.15);
    color:#fff;
    box-shadow:0 4px 12px rgba(0,0,0,0.15);
          padding:12px;
          border-radius:10px;
          margin-bottom:10px;
        ">
          <h2 style="margin:0;">🏠 Property Details </h2>
         
        </div>
    
        <!-- OWNER -->
        <div style="
          background:#fff;
          border-radius:10px;
          padding:12px;
          margin-bottom:10px;
          box-shadow:0 2px 6px rgba(0,0,0,0.2);
        ">
          <h3 style="color:#4facfe;">👤 Owner </h3>
    
          <table style="width:100%; font-size:14px">
            <tr><td><b>E-Nagarpalika ID </b></td><td>${data.e_nagarpalikaid || "-"}</td></tr>
             <tr><td><b>ULB Name</b></td><td>${data.ulbname || "-"}</td></tr>
              <tr><td><b>Ward No</b></td><td>${data.wardno || "-"}</td></tr>
                <tr><td><b>Ward Name</b></td><td>${data.wardname || "-"}</td></tr>
               <tr><td><b>Name</b></td><td>${data.ownername || "-"}</td></tr>
            <tr><td><b>Guardian</b></td><td>${data.ownergardianname || "-"}</td></tr>
            <tr><td><b>Mobile</b></td><td>${data.mobileno || "-"}</td></tr>
           
          </table>
        </div>
      
  

        <!-- IMAGE -->
        <div style="
          background:#fff;
          border-radius:10px;
          padding:10px;
          text-align:center;
          box-shadow:0 2px 6px rgba(0,0,0,0.2);
        ">
          <h3 style="color:#00c853;">📸 Property Photo</h3>
    
          <img 
            src="https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id=${PROPERTY_Relation_Id}" 
            style="width:100%; height:100%; object-fit:cover; border-radius:8px;"
            onerror="
              this.style.display='none';
              this.parentNode.innerHTML += '<div style=color:red>No Image Found</div>';
            "
          />
    
        </div>
    
      </div>
    
    </div>
    `;


                                    } catch (error) {
                                        console.error(error);

                                        return `<div style="color:red;">❌ Failed to load data</div>`;
                                    }
                                }
                            }

                        },
                    ]
                });
                view.map.add(waterLayer);
                layerRef.current = waterLayer;


            }// if end 

        }


    };



    const fetchPropertyData = async ({ dist_cd, ulb_cd, wardno, filterType = active, page = 1 }) => {
        setIsTableLoading(true);

        const baseUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/abpas_property_mview/MapServer/1/query";
        const pageSize = rows;
        const offset = pageSize * (page - 1);

        const whereParts = [
            dist_cd && `dist_cd='${dist_cd}'`,
            ulb_cd && `ulb_cd='${ulb_cd}'`,
            wardno && `wardno='${wardno}'`,
            filterType && filterType !== "total" && filterType // Only add filterType if it's not "total"
        ].filter(Boolean);

        // If filterType is "total", only use the location filters (dist_cd, ulb_cd, wardno)
        // If filterType is not "total", use all filters including the filterType
        const where = whereParts.length > 0 ? whereParts.join(" AND ") : "1=1";

        try {
            // 🔹 Fetch count first
            const countUrl = `${baseUrl}?where=${encodeURIComponent(where)}&returnCountOnly=true&f=json`;
            const countRes = await fetch(countUrl);
            const countJson = await countRes.json();
            setTotalRecords(countJson.count || 0);

            // 🔹 Fetch records
            const url = `${baseUrl}?where=${encodeURIComponent(where)}&outFields=*&returnGeometry=false&f=json&resultOffset=${offset}&resultRecordCount=${pageSize}`;
            const response = await fetch(url);
            const json = await response.json();
            const properties = json.features.map(f => f.attributes);

            if (properties.length > 0) {
                setColumns(generateTableHeaders(properties));
            } else {
                setColumns([]);
            }

            setFilteredPropertyData(properties);
            setCurrentPage(page);
            setFirst(offset);

            return properties; // ✅ return so handleLoadMore works
        } catch (err) {
            console.error("Error fetching property data:", err);
            return [];
        } finally {
            setIsTableLoading(false);
        }
    };



    useEffect(() => {
        const initLoad = async () => {
            setIsLoading(true);
            const filters = (authData?.UserType === "districtuser" || authData?.UserType === "User")
                ? { dist_cd: authData.DistrictCode, ulb_cd: authData.Ulb_Code, wardno: wardCode }
                : {};
            await fetchPropertyData({ ...filters, page: 1 });
            setIsLoading(false);
        };
        if (authData) initLoad();
    }, [authData, rows]); // Re-run if `rows` changes

    const generateTableHeaders = (data) => {
        if (!data || data.length === 0) return [];
        const excludedKeys = ["objectid", "dist_cd", "districtcode", "div_cd", "divisioncode", "Uaddgislab_sde_property_change_area", "ulb_cd", "ulbcode", "singlepage_id", "slumornonslum", "st_length(shape)", "st_area(shape)", "Photolink"];
        const excludedKeysLower = excludedKeys.map(key => key.toLowerCase());
        const keys = Object.keys(data[0]).filter(key => !excludedKeysLower.includes(key.toLowerCase()));
        return keys.map(key => ({
            field: key,
            header: key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase()).replace(/_/g, " "),
        }));
    };

    // UPDATED data fetching function for PrimeReact

    // CODE FOR DISTRICT ULB WARD



    // CODE FOR SEARCH DATA
    // Debounced search text (500ms delay)

    const [searchBy, setSearchBy] = useState("ownername");
    const [searchText, setSearchText] = useState("");
    const [searchMsg, setSearchMsg] = useState("");
    const [results, setResults] = useState([]);
    const [misLayer, setMisLayer] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [Relation_Id, setRelation_Id] = useState("0");
    const [propertyData, setpropertyData] = useState();

    const [selectedImageUrl, setSelectedImageUrl] = useState(null);
    //  BHupen code for propertinfo

    // Initialize the FeatureLayer once
    useEffect(() => {
        const layer = new FeatureLayer({
            url: "https://mpurbangis.in/server/rest/services/temp_n/view_mis_data/MapServer/97"
        });

        setMisLayer(layer);
    }, []);

    const searchLayerRef = useRef(
        new FeatureLayer({
            url: "https://mpurbangis.in/server/rest/services/temp_n/view_mis_data/MapServer/97",
            outFields: ["*"],
        })
    );


    const handleSearchChange = (value) => {
        setSearch(value);
        // debounce
        if (debounceRef.current) clearTimeout(debounceRef.current);

        debounceRef.current = setTimeout(() => {
            if (value.length < 3) {
                setSearchResults([]);
                return;
            }
            runSearch(value);
        }, 350);
    };

// SEARCH METHODS
const runSearch = async (value) => {
    try {
        if (!value || value.length < 3) return; // ✅ avoid heavy queries

        setSearchLoading(true);

        if (abortRef.current) abortRef.current.abort();
        abortRef.current = new AbortController();

        const query = searchLayerRef.current.createQuery();

        // Base filter (District / ULB / Ward)
        const filterExpr = buildFilter(districtCode, ulbCode, wardCode);

        let searchExpr = "";

        if (searchField === "mobileno") {
            // ✅ FAST (indexed)
            searchExpr = `${searchField} LIKE '${value}%'`;
        } else {
            // ⚡ Prefix search
            searchExpr = `UPPER(${searchField}) LIKE UPPER('${value}%')`;
        }

        // Apply filter + search
        query.where = filterExpr
            ? `(${filterExpr}) AND (${searchExpr})`
            : searchExpr;

        query.outFields = ["*"];
        query.returnGeometry = false; // 🚀 BIG SPEED BOOST
        query.num = 1000;

        let res = await searchLayerRef.current.queryFeatures(query);

        // 🔁 If no results → fallback to contains search
        if (res.features.length === 0) {

            const fallbackExpr = `
                UPPER(ownername) LIKE UPPER('%${value}%')
                OR mobileno LIKE '%${value}%'
                OR e_nagarpalikaid LIKE '%${value}%'
            `;

            query.where = filterExpr
                ? `(${filterExpr}) AND (${fallbackExpr})`
                : fallbackExpr;

            res = await searchLayerRef.current.queryFeatures(query);
        }

        const data = res.features.map((f) => ({
            ...f.attributes,
            geometry: f.geometry,
        }));

        setSearchResults(data);

    } catch (err) {
        if (err.name !== "AbortError") {
            console.error("Search error:", err);
        }
    } finally {
        setSearchLoading(false);
    }
};

// SEARCH METHODS

    const [DATAROW, setDATAROW] = useState(null);

    //  20 JULY  CODE FOR TBALE CLICK Based
    const handleRowClick_Table = (DATAROW) => {
        setRelation_Id(DATAROW.relation_id)
        setPROPERTY_Relation_Id(DATAROW.relation_id)


        const imageUrl = `https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id=${DATAROW.relation_id}`;
        setSelectedImageUrl(imageUrl);
        setDATAROW(DATAROW);

    };


    useEffect(() => {

        // alert("PROPERTY_Relation_Id",PROPERTY_Relation_Id);

        if (!view || !PROPERTY_Relation_Id) return;

        ZOOMTOProperty(PROPERTY_Relation_Id);

    }, [PROPERTY_Relation_Id, view]); // ✅ include view also


    const ZOOMTOProperty = async (relationId) => {

        try {
            const layer = new FeatureLayer({
                url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/MapServer/97"
            });

            const query = new Query({
                where: `relation_id='${relationId}'`,
                returnGeometry: true,
                outFields: ["*"]
            });

            // ✅ Clear old highlight
            view.graphics.removeAll();

            const result = await layer.queryFeatures(query);

            if (result.features.length === 0) {
                console.warn("No feature found for:", relationId);
                return;
            }

            const feature = result.features[0];

            // ✅ Highlight Symbol
            const graphic = new Graphic({
                geometry: feature.geometry,
                symbol: {
                    type: "simple-fill",
                    color: [98, 252, 251, 0.4],
                    outline: {
                        color: [0, 255, 255],
                        width: 2
                    }
                }
            });

            view.graphics.add(graphic);

            // ✅ Smooth zoom
            await view.goTo({
                target: feature.geometry,
                zoom: 18
            });

            // ✅ Optional: Open popup
            view.popup.open({
                features: [feature],
                location: feature.geometry.centroid
            });

        } catch (error) {
            console.error("Zoom Error:", error);
        }
    };


    // CODE FOR SEARCH DATA


    //STYLE 


    const style = {

        viewProDiv: {
            width: "850px",
        },
        app: {
            display: "grid",
            gridTemplateColumns: "1fr 420px",
            height: "100vh",
        },
        viewDiv: {
            width: "100%",
            height: "100%",
        },
        panel: {
            borderLeft: "1px solid #ddd",
            background: "#fff",
            display: "flex",
            flexDirection: "column",
        },
        panelHeader: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 12px",
            borderBottom: "1px solid #eee",
            background: "#fafafa",
        },
        title: {
            fontWeight: 700,
            fontSize: "16px",
        },
        btn: {
            padding: "6px 10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            background: "#007ac2",
            color: "#fff",
            cursor: "pointer",
        },
        searchArea: {
            padding: "10px 0px",
            borderBottom: "1px solid #eee",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
        },
        searchRow: {
            display: "flex",
            gap: "8px",
        },
        input: {
            padding: "8px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "14px",
        },
        buttonPrimary: {
            background: "#1e4f6c",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            padding: "8px 10px",
            borderRadius: "6px",
        },
        msg: {
            fontSize: "13px",
            color: "#444",
        },
        results: {
            maxHeight: "160px",
            overflow: "auto",
            border: "1px solid #eee",
            borderRadius: "6px",
        },
        accordion: {
            padding: "10px 12px",
            overflow: "auto",
        },
        card: {
            border: "1px solid #eee",
            borderRadius: "8px",
            marginBottom: "10px",
            background: "#fafafa",
        },
        cardHeader: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
            cursor: "pointer",
        },
        cardTitle: {
            fontWeight: 700,
            fontSize: "14px",
        },
        cardToggle: {
            fontSize: "13px",
            color: "#007ac2",
            background: "none",
            border: 0,
            cursor: "pointer",
        },
        cardBody: {
            padding: "10px 12px",
            display: "none", // Toggle with 'block' dynamically
        },
        cardBodyOpen: {
            display: "block",
        },
        photoImg: {
            maxWidth: "100%",
            maxHeight: "220px",
            objectFit: "cover",
            border: "1px solid #ddd",
            borderRadius: "6px",
            display: "block",
            margin: "6px auto",
        },
        noData: {
            color: "#666",
            fontStyle: "italic",
            padding: "8px 0",
        },
    };


    // CODE FOR CSS
    const thStyle = {
        padding: "8px",

        fontWeight: "bold",
        border: "1px solid white"
    };

    const tdStyle = {
        padding: "8px",
        border: "1px solid #ccc",
    };
    // CODE FOR CSS

    //STYLE

    // FUNCTION SET 

    function PropertyImage({ relationId }) {
        const [isFullscreen, setIsFullscreen] = useState(false);
        const [imgError, setImgError] = useState(false);

        const imageUrl = relationId
            ? `https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id=${relationId}`
            : "/no-image.png";

        return (
            <>
                {/* Thumbnail */}
                <div
                    style={{
                        width: 80,
                        height: 80,
                        overflow: "hidden",
                        borderRadius: 6,
                        border: "1px solid #034747ff",
                        cursor: "pointer",
                    }}
                    onClick={() => setIsFullscreen(true)}
                >
                    <img
                        src={imgError ? "/no-image.png" : imageUrl}
                        alt="Property"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                        }}
                        onError={() => setImgError(true)} // ✅ single control
                    />
                </div>

                {/* Fullscreen Modal */}
                {isFullscreen && (
                    <div
                        onClick={() => setIsFullscreen(false)}
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(0,0,0,0.8)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 9999,
                            cursor: "zoom-out",
                        }}
                    >
                        <img
                            src={imgError ? "./no-image.png" : imageUrl}
                            alt="Property Fullscreen"
                            style={{
                                maxWidth: "90%",
                                maxHeight: "90%",
                                objectFit: "contain",
                                borderRadius: 8,
                            }}
                            onError={() => setImgError(true)} // ✅ also for fullscreen
                        />
                    </div>
                )}
            </>
        );
    }
    // RESET  LAYERS
    const handleReset = () => {
        window.location.reload();
    };
    // FUNCTION SET


    return (
        <>
            <div
                style={{
                    height: isToolHeight ? "calc(100vh - 109px)" : "calc(100vh - 205px)",
                    width: "100%",
                    display: "flex",
                    overflow: "hidden",
                }}
            >

                {/* ================= MAP SECTION ================= */}
                <div
                    style={{
                        flex: 1,
                        minWidth: 0,
                        position: "relative",
                        transition: "all 0.3s ease",
                    }}
                >

                    {/* Maximize Button */}
                    <div style={{ position: "absolute", top: "15px", right: "20px", zIndex: 999 }}>
                        <button
                            onClick={toggleMaximize}
                            style={{
                                padding: "6px 14px",
                                fontSize: "13px",
                                borderRadius: "20px",
                                border: "none",
                                cursor: "pointer",
                                color: "white",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                                background: "#108181",
                            }}
                        >
                            {isMaximized ? "Minimize Map" : "Maximize Map"}
                        </button>
                    </div>

                    <div
                        ref={mapRef}
                        style={{
                            width: "100%",
                            height: "100%",
                        }}
                    />

                </div>

                {/* ================= RIGHT PANEL ================= */}

                {/* SECTION D  TABS */}
                {!isMaximized && (
                    <div
                        style={{
                            width: "540px",          // 👈 control sidebar width here
                            minWidth: "300px",
                            maxWidth: "760px",
                            background: "#719797",
                            padding: "15px",
                            overflowY: "auto",
                            boxShadow: "-4px 0 8px rgba(0,0,0,0.1)",
                            height: "100%",
                            boxSizing: "border-box",
                        }}
                    >

                        {/* Your panel content here */}

                        {/* DIV Right */}
                        {/* HEADER */}
                        <div className="tooltitlediv linear-gradian-bg">
                            <h6 className="sidebarbuttontitle text-white m-0">
                                Property Explorer
                            </h6>
                           
                        </div>

                        {/* TABS */}
                        <div className="tabs-container d-flex justify-content-between mt-3">
                            <button
                                className={`tab-btn ${activeSelect === "area" ? "active" : ""
                                    }`}
                                onClick={() => setActiveSelect("area")}
                            >
                                Select Property
                            </button>

                            <button
                                className={`tab-btn ${activeSelect === "propertyinfo" ? "active" : ""
                                    }`}
                                onClick={() => setActiveSelect("propertyinfo")}
                            >
                                Property Details
                            </button>
                            <button
                                onClick={handleReset}
                                style={{
                                    float: "right",
                                    border: "none",
                                    borderRadius: "6px",
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    cursor: "pointer",
                                    background: "linear-gradient(135deg, #d1af17, #c8e65a)",
                                    color: "#140c0c",
                                    transition: "0.3s",
                                }}
                                onMouseOver={(e) => {
                                    e.target.style.transform = "translateY(-2px)";
                                    e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.2)";
                                }}
                                onMouseOut={(e) => {
                                    e.target.style.transform = "translateY(0px)";
                                    e.target.style.boxShadow = "none";
                                }}
                            >
                                Refresh Page
                            </button>
                            {/* <button
                                className={`tab-btn ${activeSelect === "layer" ? "active" : ""
                                    }`}
                                onClick={() => setActiveSelect("layer")}
                            >
                                Layer
                            </button> */}
                        </div>

                        {/* CONTENT (SCROLLABLE) */}
                        <div
                            className="col-lg-12 col-md-12 p-lg-2 mt-2"
                            style={{ flex: 1, overflowY: "auto" }}
                        >
                            {activeSelect === "area" ? (
                                <>
                                    <div
                                        className="px-3"
                                        style={{
                                            border: "4px solid #c1e3e6ff",
                                            borderRadius: "4px",
                                        }}
                                    >
                                        {/* SELECTS */}
                                        <Select
                                            options={districts
                                                .map((d) => ({
                                                    value: d.districtCode,
                                                    label: d.districtName,
                                                }))
                                                .sort((a, b) =>
                                                    a.label.localeCompare(b.label)
                                                )}
                                            value={
                                                districtCode
                                                    ? { value: districtCode, label: selectedDistrict }
                                                    : null
                                            }
                                            onChange={(selectedOption) =>
                                                !selectedOption
                                                    ? handleRefresh()
                                                    : handleDistrictChange(selectedOption)
                                            }
                                            styles={customStyles}
                                            placeholder="Select District"
                                            isClearable
                                            className="mt-3"
                                        />

                                        <Select
                                            options={ulbs
                                                .map((u) => ({
                                                    value: u.ulbCode,
                                                    label: u.ulbName,
                                                }))
                                                .sort((a, b) =>
                                                    a.label.localeCompare(b.label)
                                                )}
                                            value={
                                                ulbCode
                                                    ? { value: ulbCode, label: selectedUlb }
                                                    : null
                                            }
                                            onChange={handleUlbChange}
                                            placeholder="Select ULB"
                                            isClearable
                                            className="mt-3"
                                            styles={customStyles}
                                        />

                                        <Select
                                            options={wards
                                                .map((w) => ({
                                                    value: w.wardCode,
                                                    label: w.displayLabel,
                                                }))
                                                .sort((a, b) => Number(a.value) - Number(b.value))}
                                            value={
                                                wardCode
                                                    ? {
                                                        value: wardCode,
                                                        label:
                                                            wards.find(
                                                                (w) => w.wardCode === wardCode
                                                            )?.displayLabel,
                                                    }
                                                    : null
                                            }
                                            onChange={handleWardChange}
                                            placeholder="Select Ward"
                                            isClearable
                                            className="mt-3"
                                            styles={customStyles}
                                        />

                                        {/* SEARCH */}
                                        <div style={style.searchArea}>
                                            <div style={{ display: "flex", gap: "8px" }}>
                                                <select
                                                    value={searchField}
                                                    onChange={(e) =>
                                                        setSearchField(e.target.value)
                                                    }
                                                    style={style.input}
                                                >
                                                    <option value="ownername">
                                                        Owner Name
                                                    </option>
                                                    <option value="mobileno">
                                                        Mobile No
                                                    </option>
                                                    <option value="e_nagarpalikaid">
                                                        E-Nagarpalika ID
                                                    </option>
                                                </select>

                                                <input
                                                    type="text"
                                                    placeholder="Search property..."
                                                    value={search}
                                                    onChange={(e) =>
                                                        handleSearchChange(e.target.value)
                                                    }
                                                    style={style.input}
                                                />
                                                {/* <button
                        style={styles.primaryButton}
                        onClick={onSearchClick}
                      >
                        Search
                      </button> */}
                                                {searchLoading && (
                                                    <div style={{ textAlign: "center", padding: "10px" }}>
                                                        <img
                                                            src="https://i.gifer.com/ZZ5H.gif"
                                                            alt="loading"
                                                            style={{ width: "40px", height: "40px" }}
                                                        />
                                                        <div style={{ marginTop: "5px", color: "#007ac2" }}>
                                                            Searching...
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {/* {searchLoading && (
                      <div style={style.msg}>Searching...</div>
                    )} */}

                                            {/* TABLE */}
                                            <div
                                                style={{
                                                    maxHeight: "45vh",
                                                    overflowY: "auto",
                                                    marginTop: "10px",
                                                }}
                                            >
                                                <table
                                                    style={{
                                                        width: "100%",
                                                        borderCollapse: "collapse",
                                                        border: "1px solid #034747ff",
                                                    }}
                                                >
                                                    <thead
                                                        style={{
                                                            position: "sticky",
                                                            top: 0,
                                                            backgroundColor: "#064151",
                                                            color: "#fff",
                                                        }}
                                                    >
                                                        <tr>
                                                            <th style={thStyle}>View</th>
                                                            <th style={thStyle}>S.No</th>
                                                            <th style={thStyle}>Photo</th>
                                                            <th style={thStyle}>Owner</th>
                                                            <th style={thStyle}>Mobile</th>
                                                            <th style={thStyle}>ID</th>
                                                            <th style={thStyle}>Relation</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {searchResults.length === 0 &&
                                                            !searchLoading ? (
                                                            <tr>
                                                                <td
                                                                    colSpan="7"
                                                                    style={{
                                                                        textAlign: "center",
                                                                        padding: "10px",
                                                                    }}
                                                                >
                                                                    No results
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            searchResults.map((item, i) => (
                                                                <tr key={i}>
                                                                    <td style={tdStyle}>
                                                                        <button
                                                                            style={{
                                                                                padding: "6px 12px",
                                                                                backgroundColor:
                                                                                    "#045b66ff",
                                                                                color: "#fff",
                                                                                border: "none",
                                                                                borderRadius: "4px",
                                                                                cursor: "pointer",
                                                                            }}
                                                                            onClick={() => {
                                                                                setActiveSelect(
                                                                                    "propertyinfo"
                                                                                );
                                                                                handleRowClick_Table(
                                                                                    item
                                                                                );
                                                                            }}
                                                                        >
                                                                            View
                                                                        </button>
                                                                    </td>
                                                                    <td style={tdStyle}>{i + 1}</td>
                                                                    <td style={tdStyle}>
                                                                        <PropertyImage
                                                                            relationId={
                                                                                item.relation_id
                                                                            }
                                                                        />
                                                                    </td>

                                                                    <td style={tdStyle}>
                                                                        {item.ownername || "N/A"}
                                                                    </td>
                                                                    <td style={tdStyle}>
                                                                        {item.mobileno || "N/A"}
                                                                    </td>
                                                                    <td style={tdStyle}>
                                                                        {item.e_nagarpalikaid || "N/A"}
                                                                    </td>
                                                                    <td style={tdStyle}>
                                                                        {item.relation_id || "N/A"}
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : activeSelect === "propertyinfo" ? (
                                <div style={{ height: "100%" }}>
                                    <PropertyMISInfo
                                        relationIdToQuery={Relation_Id}
                                        e_nagarpalikaidToQuery={
                                            DATAROW?.e_nagarpalikaid
                                        }
                                        gis_uniqueid={DATAROW?.gis_uniqueid}
                                        profileDetails={DATAROW}
                                    />
                                </div>
                            ) : (
                                <div className="px-3">

                                </div>
                            )}
                        </div>
                        {/* DIV Right */}

                    </div>
                )}
            </div>
        </>
    )
}
export default MapPointDist 
